/// <reference path="../../Common/Base/SiteEntityGrid.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class PartyRelationshipGrid extends SiteEntityGrid<PartyRelationshipRow, any> {
        protected getColumnsKey() { return PartyRelationshipColumns.columnsKey; }
        protected getDialogType() { return PartyRelationshipDialog; }
        protected getIdProperty() { return PartyRelationshipRow.idProperty; }
        protected getLocalTextPrefix() { return PartyRelationshipRow.localTextPrefix; }
        protected getService() { return PartyRelationshipService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getInitialTitle() {
            return null;
        }

        protected getColumns() {
            return super.getColumns().filter(x => x.field != PartyRelationshipRow.Fields.PartyCode);
        }

        protected getGridCanLoad() {
            return !!this._partyCode;
        }

        protected addButtonClick() {
            if (!this._partyCode)
                return;

            this.editItem({
                PartyCode: this.partyCode
            });
        }

        private _partyCode: string;

        public get partyCode() {
            return this._partyCode;
        }

        public set partyCode(value: string) {
            if (this._partyCode != value) {
                this._partyCode = value;
                this.setEquality(PartyRelationshipRow.Fields.PartyCode, value);
                this.refresh();
            }
        }
    }
}